import { token } from '@thiememeulenhoff/lit-sdk';
import { ScoreLevel } from '@thiememeulenhoff/types';
import { CSSResult } from 'lit';

export const SCORE_LEVEL_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-background-default'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-background-default'),
  [ScoreLevel.Marginal]: token('score-label-warning-background-default'),
  [ScoreLevel.Satisfactory]: token('score-label-success-background-default'),
  [ScoreLevel.Excellent]: token('score-label-success-background-default'),
};

export const SCORE_LEVEL_COLOR_HOVER_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('score-label-error-background-hover'),
  [ScoreLevel.Unsatisfactory]: token('score-label-warning-background-hover'),
  [ScoreLevel.Marginal]: token('score-label-warning-background-hover'),
  [ScoreLevel.Satisfactory]: token('score-label-success-background-hover'),
  [ScoreLevel.Excellent]: token('score-label-success-background-hover'),
};

export const SCORE_LEVEL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('foreground-inverse'),
  [ScoreLevel.Unsatisfactory]: token('foreground-inverse'),
  [ScoreLevel.Marginal]: token('foreground-inverse'),
  [ScoreLevel.Satisfactory]: token('foreground-inverse'),
  [ScoreLevel.Excellent]: token('foreground-inverse'),
};

export const SCORE_LEVEL_NEUTRAL_TEXT_COLOR_MAP: Record<ScoreLevel, CSSResult> =
  {
    [ScoreLevel.Poor]: token('status-danger-foreground'),
    [ScoreLevel.Unsatisfactory]: token('status-warning-foreground'),
    [ScoreLevel.Marginal]: token('status-warning-foreground'),
    [ScoreLevel.Satisfactory]: token('status-success-foreground'),
    [ScoreLevel.Excellent]: token('status-success-foreground'),
  };

export const SCORE_LEVEL_ICON_MAP: Record<ScoreLevel, string> = {
  [ScoreLevel.Poor]: 'close',
  [ScoreLevel.Unsatisfactory]: 'wave-triangle',
  [ScoreLevel.Marginal]: 'wave-triangle',
  [ScoreLevel.Satisfactory]: 'check',
  [ScoreLevel.Excellent]: 'check',
};

export const SCORE_LEVEL_BORDER_COLOR_MAP: Record<ScoreLevel, CSSResult> = {
  [ScoreLevel.Poor]: token('status-danger-border'),
  [ScoreLevel.Unsatisfactory]: token('status-warning-border'),
  [ScoreLevel.Marginal]: token('status-warning-border'),
  [ScoreLevel.Satisfactory]: token('status-success-border'),
  [ScoreLevel.Excellent]: token('status-success-border'),
};
